<template>
  <div class="couponBox">
    <div class="couponSearch">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="优惠券名称">
          <el-input
            v-model="formInline.title"
            placeholder="优惠券名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.user_type" placeholder="类型">
            <el-option label="vip" value="vip"></el-option>
            <el-option label="新注册" value="new_register"></el-option>
            <el-option label="非会员" value="not_vip"></el-option>
            <el-option label="所有" value="all"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="formInline.status" placeholder="审核状态">
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核失败" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用状态">
          <el-select v-model="formInline.use_status" placeholder="使用状态">
            <el-option label="正常" value="1"></el-option>
            <el-option label="关闭" value="2"></el-option>
            <el-option label="废止" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="couponTitle">
      <div class="title">优惠券列表</div>
      <div class="button">
        <el-button type="primary" @click="addCoupon"> 新增优惠券 </el-button>
      </div>
    </div>
    <div class="couponTable">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="优惠券id" align="center" width="80">
        </el-table-column>
        <el-table-column
          prop="title"
          label="优惠券名称"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column width="100" label="类型" align="center">
          <template slot-scope="scope">{{
            goodsType(scope.row.goods_type)
          }}</template>
        </el-table-column>
        <el-table-column label="优惠方式(元)" align="center" width="150">
          <template slot-scope="scope">{{ youhuifangshi(scope.row) }}</template>
        </el-table-column>
        <el-table-column
          prop="validity"
          label="券有效期(天)"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="role"
          label="使用规则"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column label="领取使用详情" align="center" width="100">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" @click="getUseDetail(scope.row)"
                >{{ scope.row.used_num }}/{{
                  Number(scope.row.number) - Number(scope.row.surplus_number)
                }}/{{ scope.row.number }}</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" align="center" width="100">
          <template slot-scope="scope">{{ status(scope.row.status) }}</template>
        </el-table-column>
        <el-table-column label="使用状态" align="center" width="100">
          <template slot-scope="scope">{{
            useStatus(scope.row.use_status)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column
          prop="admin_name"
          label="创建人"
          align="center"
          width="80"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <!-- -->
            <!-- @click="enableEdit(scope.row)" -->
            <el-button type="text" @click="detail(scope.row)">详情</el-button>
            <el-button type="text" @click="del(scope.row)">删除</el-button>
            <el-button
              type="text"
              v-if="scope.row.use_status != 3"
              @click="abolish(scope.row)"
              >废止</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.use_status == 1"
              @click="close(scope.row)"
              >关闭</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.use_status == 2"
              @click="open(scope.row)"
              >打开</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 10">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增优惠券 -->
    <el-dialog
      title="新增优惠券"
      :visible.sync="centerDialogVisible"
      width="40%"
      center
    >
      <div class="nBuild-title">基本信息</div>
      <el-form :model="form" label-width="100px" :rules="rules" ref="ruleForm">
        <el-form-item label="优惠券名称" prop="title">
          <el-input
            v-model="form.title"
            type="text"
            placeholder="请填写券名称"
            maxlength="15"
            style="width: 240px"
            show-word-limit
            >*</el-input
          >
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="优惠券类型" prop="goods_type">
              <el-select
                v-model="form.goods_type"
                style="width: 240px"
                @change="selectCouponType"
              >
                <el-option
                  v-for="(item, i) in couponType"
                  :key="i"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="会员类型"
              v-if="vipTypeNumber == 1"
              prop="vip_type"
            >
              <el-select v-model="form.vip_type">
                <el-option
                  v-for="(item, i) in vipList"
                  :key="i"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="古籍"
              v-if="vipTypeNumber == 2"
              prop="book_ids"
            >
              <el-input
                v-if="bookNames != ''"
                text="textarea"
                v-model="bookNames"
              ></el-input>
              <el-button type="primary" @click="addBook">添加</el-button>
              <!-- <el-cascader
                v-model="form.book_ids"
                @change="blurs"
                placeholder="试试搜索：指南"
                :options="options"
                :props="{ multiple: true }"
              ></el-cascader> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="优惠方式" prop="favourable_type">
              <el-select
                v-model="form.favourable_type"
                style="width: 240px"
                @change="selectpreferentialMethod"
              >
                <el-option
                  v-for="(item, i) in preferentialMethod"
                  :key="i"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="满"
              label-width="60px"
              prop="satisfy"
              v-if="preferentialMethodNumber == 1"
            >
              <el-input v-model="form.satisfy" type="text" style="width: 50px"
                >*</el-input
              >
              减
              <el-input
                v-model="form.amount"
                type="text"
                prop="amount"
                style="width: 50px; margin-right: 10px"
                >*</el-input
              >元
            </el-form-item>
            <el-form-item
              label=""
              label-width="60px"
              v-if="preferentialMethodNumber == 2"
            >
              <el-input
                :min="0.1"
                :max="9.9"
                @blur="iptBlur(form.discount, 1)"
                v-model="form.discount"
                type="number"
                style="width: 100px"
                >*</el-input
              >
              折
            </el-form-item>
            <el-form-item
              label="减"
              label-width="60px"
              prop="amount"
              v-if="preferentialMethodNumber == 3"
            >
              <el-input v-model="form.amount" type="text" style="width: 50px"
                >*</el-input
              >
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8"> </el-col> -->
        </el-row>

        <el-form-item label="发放数量" prop="number">
          <el-input v-model="form.number" type="text" style="width: 240px"
            >*</el-input
          >
        </el-form-item>
        <div style="padding: 0 20px">
          <div class="border"></div>
        </div>
        <div class="nBuild-title">基本规则</div>
        <el-form-item label="用户类型" prop="user_type">
          <el-select v-model="form.user_type" style="width: 240px">
            <el-option
              v-for="(item, i) in userTypeList"
              :key="i"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="每人限量" prop="limit">
          <el-input v-model="form.limit" type="text" style="width: 240px">
            *
          </el-input>
        </el-form-item>

        <el-form-item label="是否可叠加" prop="can_add">
          <el-radio
            v-model="form.can_add"
            v-for="(item, i) in compositionList"
            :key="i"
            :label="item.id"
            :value="item.name"
          >
            {{ item.name }}
          </el-radio>
        </el-form-item>
        <el-form-item label="有效期" prop="validity">
          <!-- <el-radio v-model="isLifespan" label="1">
            固定天数
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="margin-left:20px"
              size="mini"
            >
            </el-date-picker>
          </el-radio> -->
          <span style="margin: 0 20px">领取后，当前生效，有效天数</span>
          <el-input v-model="form.validity" type="text" style="width: 240px"
            >*</el-input
          >
          天
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" style="width: 240px"
            >*</el-input
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="nBuildCoupon('ruleForm')"
          style="width: 200px; height: 40px"
        >
          确认提交
        </el-button>
      </span>
    </el-dialog>
    <!-- 删除优惠券 -->
    <el-dialog title="提示" :visible.sync="delDialog" width="30%">
      <span>确定要删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialog = false">取 消</el-button>
        <el-button type="primary" @click="delFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 优惠券详情(改) -->
    <el-dialog
      title="优惠券详情"
      :visible.sync="changeDialogVisible"
      width="50%"
      center
    >
      <div class="nBuild-title">基本信息</div>
      <el-form :model="form1" label-width="100px" :rules="rules" ref="ruleForm">
        <el-form-item label="优惠券名称" prop="title">
          <el-input
            v-model="form1.title"
            type="text"
            placeholder="请填写券名称"
            maxlength="15"
            style="width: 240px"
            show-word-limit
            >*</el-input
          >
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="优惠券类型" prop="goods_type">
              <el-select
                v-model="form1.goods_type"
                style="width: 240px"
                @change="selectCouponType"
              >
                <el-option
                  v-for="(item, i) in couponType"
                  :key="i"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="会员类型"
              v-if="vipTypeNumber == 1"
              prop="vip_type"
            >
              <el-select v-model="form1.vip_type">
                <el-option
                  v-for="(item, i) in vipList"
                  :key="i"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="古籍ID"
              v-if="vipTypeNumber == 2"
              prop="book_ids"
            >
              <el-input
                v-if="bookNames != ''"
                text="textarea"
                v-model="bookNames"
              ></el-input>
              <el-button type="primary" @click="addBook">添加</el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="优惠方式" prop="favourable_type">
              <el-select
                v-model="form1.favourable_type"
                style="width: 240px"
                @change="selectpreferentialMethod"
              >
                <el-option
                  v-for="(item, i) in preferentialMethod"
                  :key="i"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="满"
              label-width="60px"
              prop="satisfy"
              v-if="preferentialMethodNumber == 1"
            >
              <el-input v-model="form1.satisfy" type="text" style="width: 70px"
                >*</el-input
              >
              减
              <el-input
                v-model="form1.amount"
                type="text"
                prop="amount"
                style="width: 70px; margin-right: 10px"
                >*</el-input
              >元
            </el-form-item>
            <el-form-item
              label=""
              label-width="60px"
              v-if="preferentialMethodNumber == 2"
            >
              <el-input
                :min="0.1"
                :max="9.9"
                @blur="iptBlur(form1.discount, 2)"
                v-model="form1.discount"
                type="number"
                style="width: 100px"
                >*</el-input
              >
              折
            </el-form-item>
            <el-form-item
              label="减"
              label-width="60px"
              prop="amount"
              v-if="preferentialMethodNumber == 3"
            >
              <el-input v-model="form1.amount" type="text" style="width: 70px"
                >*</el-input
              >
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8"> </el-col> -->
        </el-row>

        <el-form-item label="发放数量" prop="number">
          <el-input v-model="form1.number" type="text" style="width: 240px"
            >*</el-input
          >
        </el-form-item>
        <div style="padding: 0 20px">
          <div class="border"></div>
        </div>
        <div class="nBuild-title">基本规则</div>
        <el-form-item label="用户类型" prop="user_type">
          <el-select v-model="form1.user_type" style="width: 240px">
            <el-option
              v-for="(item, i) in userTypeList"
              :key="i"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="每人限量" prop="limit">
          <el-input v-model="form1.limit" type="text" style="width: 240px">
            *
          </el-input>
        </el-form-item>

        <el-form-item label="是否可叠加" prop="can_add">
          <el-radio
            v-model="form1.can_add"
            v-for="(item, i) in compositionList"
            :key="i"
            :label="item.id"
            :value="item.name"
          >
            {{ item.name }}
          </el-radio>
        </el-form-item>
        <el-form-item label="有效期" prop="validity">
          <!-- <el-radio v-model="isLifespan" label="1">
            固定天数
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="margin-left:20px"
              size="mini"
            >
            </el-date-picker>
          </el-radio> -->
          <span style="margin: 0 20px">领取后，当前生效，有效天数</span>
          <el-input v-model="form1.validity" type="text" style="width: 240px"
            >*</el-input
          >
          天
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form1.remark" type="textarea" style="width: 240px"
            >*</el-input
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="saveCoupon('ruleForm')"
          style="width: 150px; height: 40px"
        >
          保存
        </el-button>
        <el-button
          type="primary"
          @click="changeDialogVisible = false"
          style="width: 150px; height: 40px"
        >
          取消
        </el-button>
      </span>
    </el-dialog>
    <!-- 废止优惠券 -->
    <el-dialog title="提示" :visible.sync="abolishDialog" width="30%">
      <span>确定要废止吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="abolishDialog = false">取 消</el-button>
        <el-button type="primary" @click="abolishFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 关闭优惠券 -->
    <el-dialog title="提示" :visible.sync="closeDialog" width="30%">
      <span>确定要关闭吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog = false">取 消</el-button>
        <el-button type="primary" @click="closeFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog title="提示" :visible.sync="shDialog" width="30%">
      <span style="margin-right: 10px">审核是否通过</span>
      <el-select @change="shChange" v-model="shValue" placeholder="请选择">
        <el-option
          v-for="item in shData"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-show="isShShow"
        style="margin-top: 20px"
        type="textarea"
        placeholder="请输入未通过原因"
        v-model="auditFailed"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shDialog = false">取 消</el-button>
        <el-button type="primary" @click="shFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 打开优惠券 -->
    <el-dialog title="提示" :visible.sync="openDialog" width="30%">
      <span>确定要打开吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openDialog = false">取 消</el-button>
        <el-button type="primary" @click="openFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 领取使用详情 -->
    <el-dialog
      title="使用详情"
      class="use-detail"
      :visible.sync="userDetailDialog"
      width="40%"
    >
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #ebeef5;
        "
      >
        <div
          style="
            width: 160px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 10px;
            border-right: 1px solid #ebeef5;
          "
        >
          <p>领取率</p>
          <span>
            {{ this.useTableData.achive_scale }}
          </span>
        </div>
        <div
          style="
            width: 160px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 10px;
            border-right: 1px solid #ebeef5;
          "
        >
          <p>使用率</p>
          <span>
            {{ this.useTableData.used_scale }}
          </span>
        </div>
        <div
          style="
            width: 160px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 10px;
            border-right: 1px solid #ebeef5;
          "
        >
          <p>用券总成交额</p>
          <span>
            {{ this.useTableData.total_coupon_amount }}
          </span>
        </div>
        <div
          style="
            width: 160px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 10px;
          "
        >
          <p>优惠总金额</p>
          <span>
            {{ this.useTableData.total_order_amount }}
          </span>
        </div>
      </div>
      <div class="couponStateBox">
        <div class="couponState">
          <p>状态：</p>
          <el-select
            @change="couponStateChange"
            v-model="couponStateValue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in couponState"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <el-button type="text">导出表单</el-button>
      </div>
      <el-table :data="couponData" border style="width: 100%">
        <el-table-column label="优惠券ID" align="center">
          <template slot-scope="scope">{{ scope.row.coupon_id }}</template>
        </el-table-column>
        <el-table-column label="领取时间" align="center">
          <template slot-scope="scope">{{ scope.row.achieve_time }}</template>
        </el-table-column>
        <el-table-column label="使用时间" align="center">
          <template slot-scope="scope">{{ scope.row.use_time }}</template>
        </el-table-column>
        <el-table-column label="关联订单号" align="center">
          <template slot-scope="scope">{{ scope.row.order_id }}</template>
        </el-table-column>
        <el-table-column label="用户ID" align="center">
          <template slot-scope="scope">{{ scope.row.user_id }}</template>
        </el-table-column>
        <el-table-column label="用户名" align="center">
          <template slot-scope="scope">{{ scope.row.nickname }}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">{{
            useDetailStatus(scope.row.status)
          }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.status == 1"
              @click="abolishCoupon(scope.row)"
              >废止</el-button
            >
            <span v-else>无</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 添加古籍 -->
    <el-dialog title="古籍列表" :visible.sync="bookDialog" width="40%">
      <el-form :inline="true" :model="bookData" class="demo-form-inline">
        <el-form-item label="古籍名称">
          <el-input v-model="bookData.title" placeholder="古籍名称"></el-input>
        </el-form-item>
        <el-form-item label="古籍类型">
          <el-select v-model="bookData.type" placeholder="古籍类型">
            <el-option label="域外" value="1"></el-option>
            <el-option label="基础" value="2"></el-option>
            <el-option label="孤本" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="getBookList">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        @selection-change="handleSelectionChange"
        tooltip-effect="dark"
        :data="BooktableData"
        style="width: 100%"
        v-loading="loadings"
        ref="usermultipleTable"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="古籍ID"> </el-table-column>
        <el-table-column label="古籍名称">
          <template slot-scope="scope">{{
            scope.row.title ? scope.row.title : scope.row.name
          }}</template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="book_totalPages > 10">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="bookCurrentPage"
          :page-size="book_page_size"
          :total="book_pageTotal"
          @current-change="handleBookPageChange"
        ></el-pagination>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="cancelSelectBook"> 取消 </el-button>
        <el-button type="primary" @click="okSelectBook"> 确认 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/knowledgeApiConfig";
export default {
  data() {
    return {
      focus: false,
      loadings: false,
      bookNames: "",
      bookDatas: [],
      isShShow: false,
      shDialog: false,
      shData: [
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 2,
          label: "审核失败",
        },
      ],
      shValue: 1,
      auditFailed: "",
      couponState: [
        {
          value: 1,
          label: "待领取",
        },
        {
          value: 2,
          label: "已使用",
        },
        {
          value: 3,
          label: "已过期",
        },
        {
          value: 4,
          label: "已废止",
        },
      ],
      couponStateValue: 1,
      useTableData: {},
      couponData: [],
      form: {
        title: "", //优惠券标题
        goods_type: 1, //优惠券类型
        vip_type: "", //会员类型
        book_ids: "", //古籍ID
        favourable_type: "", //优惠方式
        satisfy: "", //优惠方式为满减时-满
        amount: "", //优惠方式为满减时-减
        discount: "", //优惠方式为折扣时
        number: "", //发放数量
        user_type: "", //用户类型
        limit: "", //每人限量
        can_add: 1, //是否叠加
        validity: "", //领取后有效期
        remark: "", //备注
        is_exchange: 2,
      },
      form1: {
        title: "", //优惠券标题
        goods_type: 1, //优惠券类型
        vip_type: "", //会员类型
        book_ids: "", //古籍ID
        favourable_type: "", //优惠方式
        satisfy: "", //优惠方式为满减时-满
        amount: "", //优惠方式为满减时-减
        discount: "", //优惠方式为折扣时
        number: "", //发放数量
        user_type: "", //用户类型
        limit: "", //每人限量
        can_add: 1, //是否叠加
        validity: "", //领取后有效期
        remark: "", //备注
        is_exchange: 2,
      },
      formData: [],
      rules: {
        title: [
          { required: true, message: "请填写优惠券标题", trigger: "blur" },
        ],
        goods_type: [
          { required: true, message: "请选择优惠券类型", trigger: "change" },
        ],
        vip_type: [
          { required: true, message: "请选择会员类型", trigger: "change" },
        ],
        favourable_type: [
          { required: true, message: "请选择优惠券方式", trigger: "change" },
        ],
        satisfy: [{ required: true, message: "请填写(满)值", trigger: "blur" }],
        amount: [{ required: true, message: "请填写(减)值", trigger: "blur" }],
        discount: [{ required: true, message: "请填写折扣", trigger: "blur" }],
        number: [
          { required: true, message: "请填写发放数量", trigger: "blur" },
        ],
        user_type: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        limit: [
          { required: true, message: "请填写每人限量数量", trigger: "blur" },
        ],
        validity: [
          { required: true, message: "请填写有效天数", trigger: "blur" },
        ],
      },
      // 优惠券类型
      couponType: [
        { id: 1, name: "VIP" },
        { id: 2, name: "古籍" },
      ],
      vipTypeNumber: 1,
      // 会员类型
      vipList: [],
      // 优惠方式
      preferentialMethod: [
        { id: 1, name: "满减" },
        { id: 2, name: "折扣" },
        { id: 3, name: "无门槛" },
      ],
      // 用户类型
      userTypeList: [
        { id: "all", name: "所有用户" },
        { id: "new_register", name: "仅新注册用户" },
        { id: "vip", name: "仅会员" },
        { id: "not_vip", name: "仅非会员" },
        // { id: 3, name: "复购3次" },
        // { id: 3, name: "复购10次" },
      ],
      // 是否叠加
      compositionList: [
        { id: 1, name: "可叠加" },
        { id: 2, name: "不可叠加" },
      ],
      preferentialMethodNumber: "",
      centerDialogVisible: false,
      changeDialogVisible: false,
      delDialog: false,
      userDetailDialog: false,
      abolishDialog: false,
      closeDialog: false,
      openDialog: false,
      bookDialog: false,
      formInline: {},
      page: {
        index: 1,
        size: 10,
        total: 0,
      },
      coupon_use_detail_page: {
        index: 1,
        size: 10,
        total: 0,
      },
      bookCurrentPage: 1,
      book_totalPages: 1,
      book_pageTotal: 10,
      book_page_size: 10,
      book_page_index: 1,

      currentPage: 1,
      totalPages: 1,
      pageTotal: 10,
      page_size: 10,
      page_index: 1,
      tableData: [],
      options: [
        { value: "1", label: "域外古籍", children: [] },
        { value: "2", label: "基础古籍", children: [] },
        { value: "3", label: "孤本古籍", children: [] },
      ],
      bookIdData: [],
      bookData: {
        type: "1",
      },
      BooktableData: [],
      coupon_id: "",
      isAbolish: false,
      bookSelectData: [],
      bookSelectIds: [],
      bookSelectName: [],
      yhqdata: {},
      is_add: false,
    };
  },
  mounted() {
    this.onSubmit();
    this.getVipList();
  },
  methods: {
    iptBlur(val, type) {
      if (val <= 0 || val > 9.9) {
        this.$message.error("折扣输入有误，请重新输入");
        if (type == 1) {
          this.form.discount = 0;
        } else {
          this.form1.discount = 0;
        }
      }
    },
    shFn() {
      if (this.isShShow == false) {
        let params = {
          status: 1,
        };
        http.put("admin/coupon/check/" + this.coupon_id, params).then((res) => {
          if (res.data.status_code == 200) {
            this.onSubmit();
            this.shDialog = false;
            this.$message.success("审核成功");
          } else {
            this.shDialog = false;
            this.$message.error(res.data.msg);
          }
        });
      } else {
        let params = {
          status: 2,
          remark: this.auditFailed,
        };
        http.put("admin/coupon/check/" + this.coupon_id, params).then((res) => {
          if (res.data.status_code == 200) {
            this.onSubmit();
            this.shDialog = false;
            this.$message.success("审核成功");
          } else {
            this.shDialog = false;
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    shChange(e) {
      console.log(e, "e");
      if (e == 2) {
        this.isShShow = true;
      } else {
        this.isShShow = false;
      }
    },
    // 优惠券审核
    submitExamine(row) {
      this.shDialog = true;
      this.coupon_id = row.id;
      console.log(row, "row");
      // if (row.status == 0) {
      //   http.put("admin/coupon/check/" + row.id).then((res) => {
      //     if (res.data.status_code == 200) {
      //       this.onSubmit();
      //       this.$message.success("优惠券已废止");
      //     } else {
      //       return false;
      //     }
      //   });
      // } else {
      // }
    },
    // 分页导航
    handlePageChange(val) {
      console.log(val);
      this.currentPage = val;
      this.onSubmit();
    },
    couponStateChange(e) {
      console.log(e, "e");
      this.couponStateValue = e;
      let params = {
        status: this.couponStateValue,
        page: this.coupon_use_detail_page.index,
        page_size: this.coupon_use_detail_page.size,
        id: this.coupon_id,
      };
      http.get("admin/coupon/coupon_use_info", { params }).then((res) => {
        if (res.data.status_code == 200) {
          this.couponData = res.data.data.coupons;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 查看领取详情
    getUseDetail(row) {
      this.userDetailDialog = true;
      this.coupon_id = row.id;
      let params = {
        status: 1,
        page: this.coupon_use_detail_page.index,
        page_size: this.coupon_use_detail_page.size,
        id: row.id,
      };
      http.get("admin/coupon/coupon_use_info", { params }).then((res) => {
        if (res.data.status_code == 200) {
          this.useTableData = res.data.data.use_info;
          this.couponData = res.data.data.coupons;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 分页导航
    handleBookPageChange(val) {
      console.log(val);
      this.bookSelectData = val;
      this.bookCurrentPage = val;
      this.getBookList();
    },
    cancelSelectBook() {
      this.bookDialog = false;
    },
    okSelectBook() {
      for (let i = 0; i < this.bookSelectData.length; i++) {
        this.bookSelectIds.push(
          this.bookData.type + ":" + this.bookSelectData[i].id
        );
        this.bookSelectName.push(
          this.bookSelectData[i].title
            ? this.bookSelectData[i].title
            : this.bookSelectData[i].name
        );
      }
      this.bookDatas = this.bookSelectName;
      this.bookNames = this.bookSelectName.toString();
      this.bookDialog = false;
    },
    // 估计搜索
    searchBook() {},
    onSubmit() {
      let that = this;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
        coupon_type: 1,
        show_unchenked: 0,
      };
      http.get("admin/coupon/list", { params }).then((res) => {
        if (res.data.status_code == 200) {
          that.tableData = res.data.data.data;
          that.currentPage = Number(res.data.data.current_page);
          that.totalPages = res.data.data.last_page;
          that.pageTotal = that.totalPages * that.page_size;
          that.loadings = false;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 添加古籍
    addBook() {
      this.bookDialog = true;
      this.getBookList();
    },
    handleSelectionChange(val) {
      console.log(val);
      this.bookSelectData = val;
    },
    toggleSelection() {
      if (this.bookNames != "") {
        let datanames =
          this.bookDatas.length != 0
            ? this.bookDatas.split(",")
            : this.yhqdata.book_names
            ? this.yhqdata.book_names.split(",")
            : "";
        for (let i = 0; i < this.BooktableData.length; i++) {
          for (let j = 0; j < datanames.length; j++) {
            if (this.bookData.type == "2") {
              setTimeout(() => {
                this.loadings = false;
                if (datanames[j] == this.BooktableData[i].title) {
                  this.$nextTick(() => {
                    this.$refs.usermultipleTable.toggleRowSelection(
                      this.BooktableData[i],
                      true
                    );
                  });
                }
              }, 500);
            } else {
              setTimeout(() => {
                this.loadings = false;
                if (datanames[j] == this.BooktableData[i].name) {
                  this.$nextTick(() => {
                    this.$refs.usermultipleTable.toggleRowSelection(
                      this.BooktableData[i],
                      true
                    );
                  });
                }
              }, 500);
            }
          }
        }
      } else {
        this.loadings = false;
      }
    },
    // 古籍列表
    getBookList() {
      let params = {
        page_size: this.book_page_size,
        page: this.bookCurrentPage,
        title: this.bookData.title,
      };
      this.loadings = true;
      if (this.bookData.type == 3) {
        http
          .get("admin/admin_books/wq_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              let data = res.data.data.data;
              this.BooktableData = data;
              this.bookCurrentPage = Number(res.data.data.current_page);
              this.book_totalPages = res.data.data.total;
              this.book_pageTotal = this.book_totalPages * this.book_page_size;
              this.toggleSelection();
              //console.log(data);
              // if (data.length > 0) {
              //   for (let i = 0; i < data.length; i++) {
              //     data[i].value = data[i].id;
              //     data[i].label = data[i].name;
              //   }
              //   //console.log(data);
              //   this.options[0].children = data;
              // }
            }
          });
      } else if (this.bookData.type == 2) {
        http
          .get("admin/admin_books/zk_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              let data = res.data.data.data;
              this.BooktableData = data;
              this.bookCurrentPage = Number(res.data.data.current_page);
              this.book_totalPages = res.data.data.total;
              this.book_pageTotal = this.book_totalPages * this.book_page_size;
              this.toggleSelection();
              // if (data.length > 0) {
              //   for (let i = 0; i < data.length; i++) {
              //     data[i].value = data[i].id;
              //     data[i].label = data[i].title;
              //   }
              //   this.options[1].children = data;
              // }
            }
          });
      } else if (this.bookData.type == 1) {
        http
          .get("admin/admin_books/yw_list", { params: params })
          .then((res) => {
            if (res.data.status_code == 200) {
              let data = res.data.data.data;
              this.BooktableData = data;
              this.bookCurrentPage = Number(res.data.data.current_page);
              this.book_totalPages = res.data.data.total;
              this.book_pageTotal = this.book_totalPages * this.book_page_size;
              this.toggleSelection();
              // if (data.length > 0) {
              //   for (let i = 0; i < data.length; i++) {
              //     data[i].value = data[i].id;
              //     data[i].label = data[i].name;
              //   }
              //   this.options[2].children = data;
              // }
            }
          });
      } else {
        return false;
      }
    },
    addCoupon() {
      this.is_add = true;
      this.vipTypeNumber = 1;
      this.centerDialogVisible = true;
      this.bookNames = "";
      this.form = {
        title: "", //优惠券标题
        goods_type: 1, //优惠券类型
        vip_type: "", //会员类型
        book_ids: "", //古籍ID
        favourable_type: "", //优惠方式
        satisfy: "", //优惠方式为满减时-满
        amount: "", //优惠方式为满减时-减
        discount: "", //优惠方式为折扣时
        number: "", //发放数量
        user_type: "", //用户类型
        limit: "", //每人限量
        can_add: 1, //是否叠加
        validity: "", //领取后有效期
        remark: "", //备注
        is_exchange: 2,
      };
    },
    // 优惠券详情
    blurs(e) {
      console.log(e);
      this.bookIdData = e;
    },
    detail(row) {
      this.is_add = false;
      this.coupon_id = row.id;
      this.form1 = {
        title: row.title, //优惠券标题
        goods_type: row.goods_type, //优惠券类型
        vip_type: row.vip_type, //会员类型
        book_ids: row.book_ids, //古籍ID
        favourable_type: row.favourable_type, //优惠方式
        satisfy: row.satisfy, //优惠方式为满减时-满
        amount: row.amount, //优惠方式为满减时-减
        discount: row.discount, //优惠方式为折扣时
        number: row.number, //发放数量
        user_type: row.user_type, //用户类型
        limit: row.limit, //每人限量
        can_add: row.can_add, //是否叠加
        validity: row.validity, //领取后有效期
        remark: row.remark, //备注
        is_exchange: 2,
      };
      this.changeDialogVisible = true;
      http.get("admin/coupon/info/" + row.id).then((res) => {
        if (res.data.status_code == 200) {
          this.yhqdata = res.data.data;
          if (this.yhqdata.goods_type == 2) {
            this.vipTypeNumber = 2;
          }
          if (res.data.data.favourable_type == 1) {
            this.preferentialMethodNumber = 1;
          } else if (res.data.data.favourable_type == 2) {
            this.preferentialMethodNumber = 2;
          } else if (res.data.data.favourable_type == 3) {
            this.preferentialMethodNumber = 3;
          }
          this.bookDatas = this.yhqdata.book_names;
          this.bookNames = this.yhqdata.book_names.toString();
          console.log(res, "res");
        }
      });
    },
    // 编辑优惠券
    saveCoupon(formName) {
      this.form.book_ids = [];
      this.form.book_ids = this.bookSelectIds.toString();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          http
            .put("admin/coupon/edit/" + this.coupon_id, this.form1)
            .then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success("保存成功");
                this.changeDialogVisible = false;
                this.onSubmit();
                //console.log(res.data.data, "data");
              }
            });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    // 新增优惠券
    nBuildCoupon(formName) {
      this.form.book_ids = [];
      this.form.book_ids = this.bookSelectIds.toString();
      //console.log(this.form);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          http.post("admin/coupon/add", this.form).then((res) => {
            if (res.data.status_code == 200) {
              this.$message.success("新增成功");
              this.centerDialogVisible = false;
              this.onSubmit();
              //console.log(res.data.data, "data");
            }
          });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    // 废止优惠券
    abolish(row) {
      this.abolishDialog = true;
      this.isAbolish = true;
      this.coupon_id = row.id;
    },
    // 废止领取详情中优惠券
    abolishCoupon(row) {
      this.abolishDialog = true;
      this.isAbolish = false;
      this.coupon_id = row.coupon_id;
    },
    // 确认是否废止
    abolishFn() {
      if (this.isAbolish == true) {
        http.put("admin/coupon/fz/" + this.coupon_id).then((res) => {
          if (res.data.status_code == 200) {
            this.abolishDialog = false;
            this.onSubmit();
            this.$message.success("优惠券已废止");
          } else {
            return false;
          }
        });
      } else {
        http
          .put("admin/coupon/coupon_user_fz/" + this.coupon_id)
          .then((res) => {
            if (res.data.status_code == 200) {
              this.abolishDialog = false;
              this.getUseDetail();
              this.$message.success("优惠券已废止");
            } else {
              return false;
            }
          });
      }
    },
    // 关闭优惠券
    close(row) {
      this.closeDialog = true;
      this.coupon_id = row.id;
    },
    // 确认是否关闭
    closeFn() {
      http.put("admin/coupon/operation/" + this.coupon_id).then((res) => {
        if (res.data.status_code == 200) {
          this.closeDialog = false;
          this.onSubmit();
          this.$message.success("优惠券已关闭");
        } else {
          this.closeDialog = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开优惠券
    open(row) {
      this.openDialog = true;
      this.coupon_id = row.id;
    },
    // 确认是否打开
    openFn() {
      http.put("admin/coupon/operation/" + this.coupon_id).then((res) => {
        if (res.data.status_code == 200) {
          this.openDialog = false;
          this.onSubmit();
          this.$message.success("优惠券已打开");
        } else {
          this.openDialog = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    // 删除优惠券
    del(row) {
      this.coupon_id = row.id;
      this.delDialog = true;
    },
    delFn() {
      http.delete("admin/coupon/delete/" + this.coupon_id).then((res) => {
        if (res.data.status_code == 200) {
          this.delDialog = false;
          this.onSubmit();
          this.currentPage = 1;
          this.$message.success("删除成功");
        } else {
          this.delDialog = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    //选择优惠券类型
    selectCouponType(e) {
      if (e == 1) {
        this.vipTypeNumber = 1;
      } else {
        this.vipTypeNumber = 2;
        this.getBookList();
      }
    },
    // 选择优惠方式
    selectpreferentialMethod(e) {
      if (e == 1) {
        this.preferentialMethodNumber = 1;
      } else if (e == 2) {
        this.preferentialMethodNumber = 2;
      } else if (e == 3) {
        this.preferentialMethodNumber = 3;
      }
    },
    // 获取vip商品类型列表
    getVipList() {
      http.get("admin/coupon/vip_goods_list").then((res) => {
        if (res.data.status_code == 200) {
          this.vipList = res.data.data;
        }
      });
    },
    //类型转换
    goodsType(type) {
      if (type == 1) {
        return "vip";
      } else if (type == 2) {
        return "古籍";
      }
    },
    youhuifangshi(row) {
      if (row.favourable_type == 1) {
        return "满" + row.satisfy + " " + "减" + row.amount;
      }
      if (row.favourable_type == 2) {
        return row.discount + "折";
      }
      if (row.favourable_type == 3) {
        return "减" + row.amount;
      }
    },
    //审核状态
    status(type) {
      if (type == 1) {
        return "审核通过";
      } else if (type == 2) {
        return "审核失败";
      } else if (type == 0) {
        return "待审核";
      }
    },
    // 使用状态
    useStatus(type) {
      if (type == 1) {
        return "正常";
      } else if (type == 2) {
        return "关闭";
      } else if (type == 3) {
        return "废止";
      }
    },
    // 领取详情使用状态
    useDetailStatus(type) {
      if (type == 1) {
        return "未使用";
      } else if (type == 2) {
        return "已使用";
      } else if (type == 3) {
        return "已过期";
      } else if (type == 4) {
        return "已废止";
      }
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
  },
};
</script>

<style scoped>
.couponBox {
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
}
.couponSearch {
  width: 100%;
  height: 60px;
}
.couponTitle {
  width: 100%;
  height: 60px;
  line-height: 60px;
}
.title {
  float: left;
  font-size: 22px;
  font-weight: bold;
}
.button {
  float: right;
}
.nBuild-title {
  padding: 20px;
  color: #169bd5;
}
.border {
  width: 100%;
  height: 1px;
  margin: 10px 0;
  background-image: linear-gradient(
    to right,
    rgb(121, 121, 121) 0%,
    rgb(121, 121, 121) 50%,
    transparent 50%
  );
  background-size: 20px 2px;
  background-repeat: repeat-x;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border: 1px solid #000;
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.couponStateBox {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.couponState {
  display: flex;
  align-items: center;
}
</style>
